import { ACCESS_TYPES, TIME_TYPES, SOLVER_TYPES } from "./AppEnums";

export const ACCESS_TYPE_NAMES = {
  Managed: "managed",
  Public: "public",
  Private: "private",
  // Shared: "shared",
  // Favorite: "favorite",
};
export const TIME_TYPE_NAMES = {
  All: "all",
  Week: "week",
  Month: "month",
  Year: "year",
};
export const SOLVER_TYPE_NAMES = {
  OPENFOAM: "openfoam",
  GERRIS: "gerris",
  SU2: "su2",
};

export const APP_ACCESS_TYPES = {
  [ACCESS_TYPE_NAMES.Managed]: ACCESS_TYPES.MANAGED,
  [ACCESS_TYPE_NAMES.Public]: ACCESS_TYPES.PUBLIC,
  [ACCESS_TYPE_NAMES.Private]: ACCESS_TYPES.PRIVATE,
  [ACCESS_TYPE_NAMES.Shared]: "UNKOWN",
  [ACCESS_TYPE_NAMES.Favorite]: "UNKOWN",
};

export const TIME_FILTER_TYPES = {
  [TIME_TYPE_NAMES.All]: TIME_TYPES.ALL,
  [TIME_TYPE_NAMES.Week]: TIME_TYPES.WEEK,
  [TIME_TYPE_NAMES.Month]: TIME_TYPES.MONTH,
  [TIME_TYPE_NAMES.Year]: TIME_TYPES.YEAR,
};

export const SOLVER_TYPES_MAP = {
  [SOLVER_TYPE_NAMES.OPENFOAM]: SOLVER_TYPES.OPENFOAM,
  [SOLVER_TYPE_NAMES.GERRIS]: SOLVER_TYPES.GERRIS,
  [SOLVER_TYPE_NAMES.SU2]: SOLVER_TYPES.SU2,
};

export const TEMPLATE_SOLVERS_LIST = [
  { label: "OpenFOAM", id: "OPENFOAM" },
  { label: "Gerris", id: "GERRIS" },
  { label: "SU2", id: "SU2" },
  // { label: "OpenLB", id: "OPENLB" },
];



export const TOPICS_LIST = [
  {label: "Particle Tracking", id: "PARTICLETRACKING"},
  {label: "Combustion", id: "COMBUSTION"},
  {label: "Multiphase Flow", id: "MULTIPHASEFLOW"},
  {label: "Fluid Solid Interaction", id: "FLUIDSOLIDINTERACTION"},
  {label: "Heat Transfer", id: "HEATTRANSFER"},
  {label: "Turbulence", id: "TURBULENCE"},
  {label: "Incompressible Flow", id: "INCOMPRESSIBLEFLOW"}  
]
export const INDUSTRIES_LIST = [
  {label: "Aerospace", id: "AEROSPACE"},
  {label: "Automotive", id: "AUTOMOTIVE"},
  {label: "Chemical", id: "CHEMICAL"},
  {label: "Energy", id: "ENERGY"},
  {label: "Marine", id: "MARINE"},
  {label: "Oil and Gas", id: "OILANDGAS"},
  {label: "Pharmaceutical", id: "PHARMACEUTICAL"},
  {label: "Water and Wastewater", id: "WATERANDWASTEWATER"},
  {label: "Other", id: "OTHER"}
]

export const ROOT_FOLDER_PATH = "";